import React, { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sessionActions } from "../../../store";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

const DropdownProfile = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const history = useHistory();

    const dispatch = useDispatch();
    const user = useSelector((state) => state.session.user) || {};

    const handleToggel = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const logOut = async () => {
        await fetch("/api/user/logout", { method: "DELETE" });
        dispatch(sessionActions.updateUser(null));
        setRedirect(true);
    };

    const editarPerfilHandler = () => {
        if (user) {
            history.push("/usuario/" + user.id);
        } else {
            logOut();
        }
    };

    return redirect ? (
        <Redirect to="/login" />
    ) : (
        <Dropdown isOpen={dropdownOpen} toggle={() => handleToggel()} className="navbar-item navbar-user dropdown" tag="div">
            <DropdownToggle tag="a" className="navbar-link dropdown-toggle d-flex align-items-center">
                <div className="image image-icon bg-gray-800 text-gray-600">
                    <i className="fa fa-user"></i>
                </div>
                <span>
                    <span className="d-none d-md-inline">{user.name ? user.name : ""}</span>
                    <b className="caret"></b>
                </span>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu dropdown-menu-end" end tag="div">
                <DropdownItem onClick={editarPerfilHandler}>Editar Perfil</DropdownItem>
                {/* <DropdownItem className="d-flex align-items-center">
                    Inbox
                    <span className="badge bg-danger rounded-pill ms-auto pb-4px">2</span>
                </DropdownItem>
                <DropdownItem>Configuraciones</DropdownItem> */}
                <div className="dropdown-divider"></div>
                <DropdownItem onClick={logOut}>Salir</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default DropdownProfile;
